var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoToPhoneNumbersPrimaryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.99,
    height: 10.095,
    viewBox: "0 0 9.99 10.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone_1_",
    "data-name": "phone (1)",
    d: "M11.1,8.809v1.369a.917.917,0,0,1-.293.676.9.9,0,0,1-.692.236A9.054,9.054,0,0,1,3.5,6.951,9.087,9.087,0,0,1,2.116,2.995a.918.918,0,0,1,.233-.7A.9.9,0,0,1,3.015,2H4.371a.907.907,0,0,1,.9.785,5.906,5.906,0,0,0,.316,1.282.919.919,0,0,1-.2.963l-.574.58A7.267,7.267,0,0,0,7.526,8.348l.574-.58a.9.9,0,0,1,.954-.205,5.758,5.758,0,0,0,1.27.319.91.91,0,0,1,.777.926Z",
    transform: "translate(-1.612 -1.5)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToPhoneNumbersPrimaryIcon);
export default __webpack_public_path__ + "static/media/go-to-phone-numbers-primary-icon.dbea398707e381d1a11350315eaeea01.svg";
export { ForwardRef as ReactComponent };